import {
  UPDATE_QUEUE_FILTER,
  LOAD_LINKS_SUCCESS,
  ADD_LINK_SUCCESS,
  CHANGE_LINK_SUCCESS,
  EMPTY_LINKS_LIST,
  UPDATE_LINKS_SORTING
} from './action-types'

import 'firebase'
import { FirebaseList, firebaseSuccessAction } from 'modules/firebase'
import SiteLink from './site-link'


const links = new FirebaseList(SiteLink)

export function updateQueueFilter(filter) {
  return {
    type: UPDATE_QUEUE_FILTER,
    payload: filter
  }
}

export function loadQueueLinks(queueId) {
  return dispatch => {
    links.path = `/links/${queueId}`
    links.subscribe(dispatch, {
      onLoad: firebaseSuccessAction(LOAD_LINKS_SUCCESS),
      onAdd: firebaseSuccessAction(ADD_LINK_SUCCESS),
      onChange: firebaseSuccessAction(CHANGE_LINK_SUCCESS)
    })
  }
}

export function unsubscribe() {
  links.unsubscribe()
  return { type: EMPTY_LINKS_LIST }
}

export function sort({ sortBy, sortDirection }) {
  return { type: UPDATE_LINKS_SORTING, payload: { sortBy, sortDirection } }
}



// WEBPACK FOOTER //
// ./src/modules/links/actions.js